const openOnboardingModal = ({ commit }, { triggerOrigin } = {}) => {
  commit('SET_IS_ONBOARDING_MODAL_VISIBLE', true);
  commit('SET_ONBOARDING_MODAL_TRIGGER_ORIGIN', triggerOrigin ?? '');
};

const closeOnboardingModal = ({ commit }) => {
  commit('SET_IS_ONBOARDING_MODAL_VISIBLE', false);
};

export default {
  openOnboardingModal,
  closeOnboardingModal,
};
